<script>
import CreditTransactions from '@/V2/credit/components/CreditTransactions';

export default {
  components: { CreditTransactions },
};
</script>

<template>
  <div class="credit-transactions-page d-flex justify-content-center i-pt-13">
    <credit-transactions></credit-transactions>
  </div>
</template>

<style lang="scss" scoped>
.credit-transactions-page {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  .credit-transactions {
    width: 1200px;

    @media screen and (max-width: 1500px) {
      width: 96%;

      :deep(.i-table-row) {
        .method {
          display: none;
        }
      }
    }

    @media screen and (max-width: 1200px) {
      :deep(.i-table-row) {
        .source {
          display: none;
        }
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .credit-transactions {
      :deep(.i-table-row) {
        .source {
          display: none;
        }
      }
    }
  }
}
</style>
